import React from "react";
import { Modal, Typography } from "antd";

const { Text } = Typography;

// 加油单识别纠正燃油报告：确认 / 改绑 / 拒绝后展示报告侧变化（D14/D19/D20）。
// 这份摘要只是当次操作的结果，不能代替再次打开时油量区的审核最终值主数字（D25）。

export const AUDIT_FIELD_LABELS = {
    previous_fuel_kg: "加油前",
    out_fuel_kg: "加油后（OUT）",
    fuel_uplift_kg: "加油量 kg",
    fuel_uplift_liters: "加油量 L",
    fuel_density: "密度",
    block_fuel_kg: "BH 油耗",
    flight_fuel_kg: "FH 油耗",
    data_completeness: "完整度",
    status: "状态",
};

const CORRECTION_STATUS_TEXT = {
    corrected: "已按审核最终值纠正该航班燃油报告：",
    skipped_no_report: "该航班暂无燃油报告，已跳过（不新建报告）。",
    no_change: "报告油量与审核最终值一致，无需修改。",
    // 受同航班已确认 Flight Log 接管保护，全字段让位跳过（AC-S3-02 / B-08）
    skipped_by_flight_log: "受已确认 Flight Log 保护，未覆盖报告油量。",
};

const fmtVal = (v) => (v === null || v === undefined || v === "" ? "空" : String(v));

// skipped 明细文案：区分「受 Flight Log 保护已跳过」（纠正时）、
// 「由 Flight Log 接管无需回退」（回退时）与「已被人工修改不回退」
const skippedReasonText = (s) => {
    if (s?.reason === "skipped_by_flight_log") return "因受已确认 Flight Log 保护而跳过（保留当前值，图片值不覆盖）";
    if (s?.reason === "covered_by_flight_log") return "当前由已确认 Flight Log 接管，无需回退";
    return "之后已被人工修改，不回退";
};

const ReportChanges = ({ reports }) => (
    <div style={{ marginTop: 8 }}>
        {(reports || []).map((r) => (
            <div key={r.fuel_report_id} style={{ marginBottom: 10 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    报告 {String(r.fuel_report_id).slice(0, 8)}…
                </Text>
                {Object.entries(r.changes || {}).map(([f, c]) => (
                    <div key={f} style={{ fontSize: 13 }}>
                        {AUDIT_FIELD_LABELS[f] || f}：{fmtVal(c?.old)} → {fmtVal(c?.new)}
                    </div>
                ))}
                {Object.entries(r.skipped || {}).map(([f, s]) => (
                    <div key={f} style={{ fontSize: 13, color: "#fa8c16" }}>
                        {AUDIT_FIELD_LABELS[f] || f}：保留当前值 {fmtVal(s?.current ?? s?.current_value)}
                        （图片值 {fmtVal(s?.image_value)}，{skippedReasonText(s)}）
                    </div>
                ))}
            </div>
        ))}
    </div>
);

/**
 * 展示燃油报告纠正 / 回退结果。
 * correction: {status, reports:[{fuel_report_id, changes}]}（确认/改绑后）
 * revert: {reports:[{fuel_report_id, changes, skipped}]}（改绑/拒绝已确认图片后）
 */
export const showCorrectionResultModal = ({ title = "燃油报告纠正结果", correction, revert }) => {
    const hasRevert = (revert?.reports || []).length > 0;
    Modal.info({
        title,
        width: 520,
        content: (
            <div>
                {correction && (
                    <div style={{ marginBottom: hasRevert ? 12 : 0 }}>
                        <Text>{CORRECTION_STATUS_TEXT[correction.status] || correction.status}</Text>
                        <ReportChanges reports={correction.reports} />
                    </div>
                )}
                {hasRevert && (
                    <div>
                        <Text>已回退本图此前对燃油报告的纠正：</Text>
                        <ReportChanges reports={revert.reports} />
                    </div>
                )}
            </div>
        ),
    });
};

/** D18 硬阻断（409 fuel_form_image_flight_already_bound）的统一提示文案。 */
export const alreadyBoundMessage = (detail) => `${detail?.message || "该航班已被其他已确认加油单图片绑定"}；请先拒绝或改绑走旧图片，再操作本图`;

export const isAlreadyBoundError = (err) => err?.response?.data?.detail?.code === "fuel_form_image_flight_already_bound";

export default showCorrectionResultModal;
